import { api } from "../../http";

async function PostIDataLayout(data) {
  try {
    
    const layout = await api.post(`/layout`,data);
    return layout;

  } catch (e) {
    console.log(e.message);
  }
}

export { PostIDataLayout };
